import React from 'react';
import DownloadReportPortfolio from './DownloadReportPortfolio';

const DownloadHalfHourlyPortfolio = () => (
  <DownloadReportPortfolio reportType="half-hourly" />
);

export default DownloadHalfHourlyPortfolio;
